import moment from 'moment';
import { checkRules } from '../../../../../../utils/formRules';
import { TABLEATTR } from '../../../Templates/Create/Delivery/formItems';

export const sortRegions = (regions) => {
  return TABLEATTR.slice(1).map((region) => {
    const find = regions.find((r) => {
      return r.data === region;
    });
    if (find) return find;
    else return { data: region };
  });
};

export const PRE_DELIVERY_NOTES_ATTRS = [
  'mash_control',
  'detailed_location',
  'arriving_time',
  'start_discharging_time',
  'finish_discharging_time',
  'arriving_date',
];
export const PRE_DELIVERY_NOTES_ATTRS_CEMEX = [
  'plant',
  'recipe',
  'delivered',
  'manufacture_time',
];

export const PRE_DELIVERY_NOTES_MASH_CONTROL_ATTRS = [
  'slump',
  'specimens_number',
  'mash_control_extra',
];

const DEFAULT_ELEMENTS_STATE = {
  Pilares: false,
  'Muros portantes': false,
  Pilotes: false,
  Pilas: false,
  Vigas: false,
  Forjados: false,
  'Tableros puente': false,
  'Muros contención': false,
  Zapatas: false,
  Losas: false,
  'Estribos puente': false,
  Bloques: false,
  'Losas marco': false,
  Riostras: false,
  Encepados: false,
  Pantallas: false,
  Micropilotes: false,
};

export const VALIDABLE_FALSE = {
  docket_number: false,
  plant: false,
  arriving_date: false,
  recipe: false,
  delivered: false,
  manufacture_time: false,
  concrete_id: false,
};

export const VALIDABLE_TRUE = {
  docket_number: true,
  plant: true,
  arriving_date: true,
  recipe: true,
  delivered: true,
  manufacture_time: true,
  concrete_id: true,
};
const CONTROLTIME = moment('22:00', 'HH:mm');

const undefinedError = (checkRulesArray) => {
  if (
    checkRulesArray.filter(
      (rule) => rule[0].id === 'required' || rule[0].id === 'hour',
    ).length
  )
    return false;
  else return true;
};

const subtract2Hours = (time) => {
  return moment(time.subtract(2, 'hours').format('HH:mm'), 'HH:mm');
};

const validateArrivingTime = ({
  arriving_time,
  manufacture_time,
  start_discharging_time,
  finish_discharging_time,
  limit_time,
}) => {
  const errors = checkRules(arriving_time.value, arriving_time.rules);
  if (errors.length === 0) {
    let momentArrivingTime = moment(arriving_time.value, 'HH:mm');
    let momentManufactureTime = moment(manufacture_time.value, 'HH:mm');
    let momentStartDischargingTime = moment(
      start_discharging_time.value,
      'HH:mm',
    );
    let momentFinishDischargingTime = moment(
      finish_discharging_time.value,
      'HH:mm',
    );
    let momentLimitValue = moment(limit_time.value, 'HH:mm');
    if (CONTROLTIME.diff(momentManufactureTime) <= 0) {
      momentArrivingTime = subtract2Hours(momentArrivingTime);
      momentManufactureTime = subtract2Hours(momentManufactureTime);
      momentStartDischargingTime = subtract2Hours(momentStartDischargingTime);
      momentFinishDischargingTime = subtract2Hours(momentFinishDischargingTime);
      momentLimitValue = subtract2Hours(momentLimitValue);
    }
    if (
      undefinedError(manufacture_time.status) &&
      momentArrivingTime.diff(momentManufactureTime) < 0
    )
      errors.push([{ id: `multiple_hour.major.equal.manufacture_time` }, {}]);
    if (
      undefinedError(start_discharging_time.status) &&
      momentArrivingTime.diff(momentStartDischargingTime) > 0
    )
      errors.push([
        { id: `multiple_hour.minor.equal.start_discharging_time` },
        {},
      ]);
    if (
      undefinedError(finish_discharging_time.status) &&
      momentArrivingTime.diff(momentFinishDischargingTime) >= 0
    )
      errors.push([{ id: `multiple_hour.minor.finish_discharging_time` }, {}]);
    if (
      undefinedError(limit_time.status) &&
      momentArrivingTime.diff(momentLimitValue) >= 0
    )
      errors.push([{ id: `multiple_hour.minor.limit_time` }, {}]);
  }
  arriving_time.status = errors;
  return { arriving_time };
};

export const parseElementsToString = (items, separator) => {
  items = Object.keys(items).reduce(
    (previousValue, currentValue) =>
      items[currentValue]
        ? previousValue + `${currentValue}${separator}`
        : previousValue,
    '',
  );
  if (items.length) items = items.substring(0, items.length - separator.length);
  return items;
};

const validateStartDischargingTime = ({
  arriving_time,
  manufacture_time,
  start_discharging_time,
  finish_discharging_time,
  limit_time,
}) => {
  const errors = checkRules(
    start_discharging_time.value,
    start_discharging_time.rules,
  );
  if (errors.length === 0) {
    let momentArrivingTime = moment(arriving_time.value, 'HH:mm');
    let momentManufactureTime = moment(manufacture_time.value, 'HH:mm');
    let momentStartDischargingTime = moment(
      start_discharging_time.value,
      'HH:mm',
    );
    let momentFinishDischargingTime = moment(
      finish_discharging_time.value,
      'HH:mm',
    );
    let momentLimitValue = moment(limit_time.value, 'HH:mm');
    if (CONTROLTIME.diff(momentManufactureTime) < 0) {
      momentArrivingTime = subtract2Hours(momentArrivingTime);
      momentManufactureTime = subtract2Hours(momentManufactureTime);
      momentStartDischargingTime = subtract2Hours(momentStartDischargingTime);
      momentFinishDischargingTime = subtract2Hours(momentFinishDischargingTime);
      momentLimitValue = subtract2Hours(momentLimitValue);
    }
    if (
      undefinedError(arriving_time.status) &&
      momentStartDischargingTime.diff(momentArrivingTime) < 0
    )
      errors.push([{ id: `multiple_hour.major.equal.arriving_time` }, {}]);
    if (
      undefinedError(finish_discharging_time.status) &&
      momentStartDischargingTime.diff(momentFinishDischargingTime) >= 0
    )
      errors.push([{ id: `multiple_hour.minor.finish_discharging_time` }, {}]);
    if (
      undefinedError(limit_time.status) &&
      momentStartDischargingTime.diff(momentLimitValue) >= 0
    )
      errors.push([{ id: `multiple_hour.minor.limit_time` }, {}]);
  }
  start_discharging_time.status = errors;
  return { start_discharging_time };
};

const validateFinishDischargingTime = ({
  manufacture_time,
  start_discharging_time,
  finish_discharging_time,
  limit_time,
}) => {
  const errors = checkRules(
    finish_discharging_time.value,
    finish_discharging_time.rules,
  );
  if (errors.length === 0) {
    let momentManufactureTime = moment(manufacture_time.value, 'HH:mm');
    let momentStartDischargingTime = moment(
      start_discharging_time.value,
      'HH:mm',
    );
    let momentFinishDischargingTime = moment(
      finish_discharging_time.value,
      'HH:mm',
    );
    let momentLimitValue = moment(limit_time.value, 'HH:mm');
    if (CONTROLTIME.diff(momentManufactureTime) < 0) {
      momentManufactureTime = subtract2Hours(momentManufactureTime);
      momentStartDischargingTime = subtract2Hours(momentStartDischargingTime);
      momentFinishDischargingTime = subtract2Hours(momentFinishDischargingTime);
      momentLimitValue = subtract2Hours(momentLimitValue);
    }
    if (
      undefinedError(start_discharging_time.status) &&
      momentFinishDischargingTime.diff(momentStartDischargingTime) <= 0
    )
      errors.push([{ id: `multiple_hour.major.start_discharging_time` }, {}]);
    if (
      undefinedError(limit_time.status) &&
      momentFinishDischargingTime.diff(momentLimitValue) > 0
    )
      errors.push([{ id: `multiple_hour.minor.equal.limit_time` }, {}]);
  }
  finish_discharging_time.status = errors;
  return { finish_discharging_time };
};

const executeTimeValidations = ({
  manufacture_time,
  arriving_time,
  start_discharging_time,
  finish_discharging_time,
  limit_time,
}) => {
  return {
    ...validateArrivingTime({
      arriving_time,
      manufacture_time,
      start_discharging_time,
      finish_discharging_time,
      limit_time,
    }),
    ...validateStartDischargingTime({
      arriving_time,
      manufacture_time,
      start_discharging_time,
      finish_discharging_time,
      limit_time,
    }),
    ...validateFinishDischargingTime({
      manufacture_time,
      start_discharging_time,
      finish_discharging_time,
      limit_time,
    }),
  };
};

const customFloatValidation = (objectForm, newValue) => {
  objectForm.value = String(newValue || '').replaceAll(/\n/g, '');
  objectForm.status = checkRules(objectForm.value, objectForm.rules);
  return objectForm;
};

export const FORMSATTR = {
  templateName: {
    rules: { required: true, maxLength: 30, type: 'string' },
    value: '',
    status: [],
  },
  supplier_id: {
    rules: { required: true, maxLength: 100, type: 'string' },
    value: '',
    status: [],
  },
  docket_number: {
    rules: { required: true, maxLength: 10, type: 'integer' },
    value: '',
    status: [[{ id: 'required' }, {}]],
  },
  plant: {
    rules: { required: true, maxLength: 30, type: 'fullString' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: ({ plant }, newValue) => {
      plant.value = newValue;
      plant.status = checkRules(
        newValue,
        {
          required: true,
          type: 'plant',
        },
        'plant.validation',
      );
      // recipe.status = []; //REMOVE THIS
      return { plant };
    },
  },
  arriving_date: {
    rules: { required: true, type: 'date' },
    value: '',
    status: [[{ id: 'required' }, {}]],
  },
  recipe: {
    rules: { required: true, type: 'recipe' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: ({ recipe, project }, newValue) => {
      newValue = String(newValue);
      // newValue = newValue?.replace(/q|h|f|e|i|s|p|b|f|l/gi, (letter) =>
      //   letter.toUpperCase(),
      // );
      if (project.value === ' EHE') {
        newValue = newValue?.replace(/A|B|C|/gi, (letter) =>
          letter.toLowerCase(),
        );
      }
      newValue = newValue?.replace('Ha', 'HA');
      // newValue = newValue?.replace('/b', '/B');
      recipe.value = newValue;

      recipe.status = checkRules(newValue, {
        required: true,
        type: project.value,
      });
      // recipe.status = []; //REMOVE THIS
      return { recipe };
    },
  },
  delivered: {
    rules: { required: true, minValue: 1, maxValue: 10, type: 'float' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: ({ delivered }, newValue) => ({
      delivered: customFloatValidation(delivered, newValue),
    }),
  },
  delivery_company: {
    rules: { maxLength: 100, type: 'fullString' },
    value: '',
    status: [],
  },
  truck: {
    rules: { type: 'plate' },
    value: '',
    status: [],
  },
  driver: {
    rules: { maxLength: 30, type: 'fullString' },
    value: '',
    status: [],
  },
  delivery_company_cif: {
    rules: { type: 'cif' },
    value: '',
    status: [],
  },
  project: {
    rules: { type: 'string' },
    value: '',
    status: [],
  },
  manufacture_time: {
    rules: { type: 'hour', required: true },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: (
      {
        manufacture_time,
        arriving_time,
        start_discharging_time,
        finish_discharging_time,
        limit_time,
      },
      newValue,
    ) => {
      const ruleResult = checkRules(newValue, manufacture_time.rules);
      manufacture_time.status = ruleResult;
      manufacture_time.value = newValue;
      limit_time.value =
        manufacture_time.status.length === 0
          ? moment(newValue, 'HH:mm').add(90, 'm').format('HH:mm')
          : '';
      limit_time.status = ruleResult;
      return {
        manufacture_time,
        limit_time,
        ...executeTimeValidations({
          manufacture_time,
          arriving_time,
          start_discharging_time,
          finish_discharging_time,
          limit_time,
        }),
      };
    },
  },
  limit_time: {
    rules: {},
    value: '',
    status: [],
  },
  concrete_id: {
    rules: { maxLength: 30, type: 'concrete_id', required: true },
    value: '',
    status: [],
    // customValidation: ({ concrete_id }, newValue) => ({}),
  },
  compound: {
    rules: { minValue: 199, maxValue: 401, type: 'integer' },
    value: '',
    status: [],
  },
  relation_wc: {
    rules: { minValue: 0, maxValue: 0.65, type: 'float' },
    value: '',
    status: [],
    customValidation: ({ relation_wc }, newValue) => ({
      relation_wc: customFloatValidation(relation_wc, newValue),
    }),
  },
  admixtures_id: {
    rules: { maxLength: 60, type: 'fullString' },
    value: '',
    status: [],
  },
  admixtures_quantity: {
    rules: { type: 'float' },
    value: '',
    status: [],
    customValidation: ({ admixtures_quantity }, newValue) => ({
      admixtures_quantity: customFloatValidation(admixtures_quantity, newValue),
    }),
  },
  admixtures_extra: {
    rules: { maxLength: 30, type: 'string' },
    value: '',
    status: [],
  },
  detailed_location: {
    rules: { maxLength: 60, type: 'fullString', required: true },
    value: '',
    status: [[{ id: 'required' }, {}]],
  },
  slump: {
    rules: { minValue: 0, maxValue: 220, required: true, type: 'integer' },
    value: '',
    status: [],
  },
  specimens_number: {
    rules: { minValue: 2, maxValue: 20, required: true, type: 'integer' },
    value: '',
    status: [],
  },
  mash_control: {
    rules: { type: 'boolean' },
    value: false,
    status: [],
    customValidation: (
      { mash_control, slump, specimens_number, mash_control_extra },
      newValue,
    ) => {
      mash_control.value = newValue;
      mash_control.status = checkRules(newValue, mash_control.rules);

      if (newValue) {
        slump.value = '';
        slump.status = checkRules('', slump.rules);
        specimens_number.value = '';
        specimens_number.status = checkRules('', specimens_number.rules);
      } else {
        slump.value = undefined;
        slump.status = [];
        specimens_number.value = 0;
        specimens_number.status = [];
      }

      mash_control_extra.value = false;
      return { mash_control, slump, specimens_number, mash_control_extra };
    },
  },
  mash_control_extra: {
    rules: { type: 'boolean' },
    value: false,
    status: [],
  },
  start_discharging_time: {
    rules: { required: true, type: 'hour' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: (
      {
        manufacture_time,
        arriving_time,
        start_discharging_time,
        finish_discharging_time,
        limit_time,
      },
      newValue,
    ) => {
      start_discharging_time.value = newValue;
      return {
        ...executeTimeValidations({
          manufacture_time,
          arriving_time,
          start_discharging_time,
          finish_discharging_time,
          limit_time,
        }),
      };
    },
  },
  finish_discharging_time: {
    rules: { required: true, type: 'hour' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: (
      {
        manufacture_time,
        arriving_time,
        start_discharging_time,
        finish_discharging_time,
        limit_time,
      },
      newValue,
    ) => {
      finish_discharging_time.value = newValue;
      return {
        ...executeTimeValidations({
          manufacture_time,
          arriving_time,
          start_discharging_time,
          finish_discharging_time,
          limit_time,
        }),
      };
    },
  },
  elements: {
    rules: { required: true },
    value: { ...DEFAULT_ELEMENTS_STATE },
    status: [[{ id: 'required' }, {}]],
    customValidation: ({ elements }, newValue) => {
      if (typeof newValue === 'string') {
        elements.value = { ...DEFAULT_ELEMENTS_STATE };
        newValue.split(',').forEach((key) => (elements.value[key] = true));
      } else elements.value = { ...elements.value, ...newValue };
      if (
        Object.keys(elements.value).reduce(
          (pre, key) => pre + elements.value[key],
          0,
        ) === 0
      )
        elements.status = [[{ id: 'required' }, {}]];
      else elements.status = [];
      return { elements };
    },
  },
  arriving_time: {
    rules: { required: true, type: 'hour' },
    value: '',
    status: [[{ id: 'required' }, {}]],
    customValidation: (
      {
        manufacture_time,
        arriving_time,
        start_discharging_time,
        finish_discharging_time,
        limit_time,
      },
      newValue,
    ) => {
      arriving_time.value = newValue;
      return executeTimeValidations({
        manufacture_time,
        arriving_time,
        start_discharging_time,
        finish_discharging_time,
        limit_time,
      });
    },
  },
};
